import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'react-final-form'
import { FieldArray } from 'react-final-form-arrays'
import FeeTypeSelect from '../ticket-fees-invoicing/FeeTypeSelect'
import TicketFee from '../ticket-fees-invoicing/TicketFee'
import { formatValue } from '../../utilities/randomUtilities'

export default function AddFeeFields ({ asset, feeTypes, form, assetIndex }) {
  const handleFeeTypeSelect = (selectedOption, form, ticketFeeTotal) => {
    if (selectedOption?.value) {
      const feeTypeId = selectedOption.value
      const feeType = feeTypes.find(feeType => feeType.id === feeTypeId)

      const newFee = {
        feeType: {
          name: feeType.name,
          id: feeType.id
        },
        quantity: 1,
        amount: feeType.defaultAmount,
        total: feeType.defaultAmount,
        description: feeType.description,
        id: null
      }

      const values = form.getState().values

      if (asset) {
        const updatedAssets = values.assetDetails.map((asset, idx) => {
          if (idx === assetIndex) {
            return {
              ...asset,
              ticketFees: [...(asset.ticketFees || []), newFee]
            }
          }
          return asset
        })
        form.change('assetDetails', updatedAssets)
      } else {
        form.batch(() => {
          form.mutators.push('ticketFees', {
            feeType: {
              name: feeType.name,
              id: feeType.id
            },
            quantity: 1,
            amount: feeType.defaultAmount,
            total: feeType.defaultAmount,
            description: feeType.description,
            id: null
          })
          form.change('feeTypeId', null)
        })
      }
    }
  }

  const onDestroyTicketFeeForAsset = (form, feeIndex, ticketFeeTotal) => {
    const formState = form.getState()
    const asset = formState.values?.assetDetails?.[assetIndex]
    if (asset) {
      form.mutators.remove(`assetDetails[${assetIndex}].ticketFees`, feeIndex)
    } else {
      const deletedTicketFees = formState.values.deletedTicketFees
      const ticketFeeId = formState.values.ticketFees[feeIndex].id

      if (ticketFeeId) {
        form.change('deletedTicketFees', [...[ticketFeeId], ...deletedTicketFees])
      }
      form.mutators.remove('ticketFees', feeIndex)
    }
  }

  const feeTotal = (ticketFees) => {
    if (ticketFees?.length > 0) {
      const amounts = ticketFees?.map(ticketFee => Number(ticketFee.total) || 0)
      return amounts.reduce((a, b) => a + b, 0)
    }
    return 0
  }

  const getTicketFees = () => {
    return asset ? form.getState().values?.assetDetails[assetIndex]?.ticketFees : form.getState().values?.ticketFees
  }

  const ticketFeeTotal = feeTotal(getTicketFees())

  const feeTypeFieldName = asset ? `${asset}.feeTypeId` : 'feeTypeId'

  return (
    <>
      <Field name={feeTypeFieldName}>
        {({ input }) => (
          <>
            <label htmlFor={feeTypeFieldName} className='control-label'>Select a Fee Type</label>
            <FeeTypeSelect
              handleSelect={handleFeeTypeSelect}
              options={feeTypes}
              input={input}
              ticketFeeTotal={ticketFeeTotal}
              form={form}
            />
          </>
        )}
      </Field>
      <FieldArray name={`${asset ? `${asset}.ticketFees` : 'ticketFees'}`}>
        {({ fields }) => {
          const ticketFeeValue = fields.value || []
          return fields.map((ticketFee, idx) => (
            <TicketFee
              key={ticketFee}
              ticketFee={ticketFee}
              onDestroy={onDestroyTicketFeeForAsset}
              ticketFeeTotal={ticketFeeTotal}
              form={form}
              value={ticketFeeValue[idx]}
              index={idx}
              formatValue={formatValue}
              isRecurring
            />
          ))
        }}
      </FieldArray>
    </>
  )
}

AddFeeFields.propTypes = {
  asset: PropTypes.string,
  feeTypes: PropTypes.array.isRequired,
  form: PropTypes.object.isRequired,
  assetIndex: PropTypes.number
}
